var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.507,
    height: 28.374,
    viewBox: "0 0 21.507 28.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "applications",
    transform: "translate(-844.283 -969.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M862.557,997.525h-15.04a3.237,3.237,0,0,1-3.234-3.233V972.384a3.238,3.238,0,0,1,3.234-3.233h15.04a3.238,3.238,0,0,1,3.233,3.233v21.908A3.237,3.237,0,0,1,862.557,997.525Zm-15.04-26.374a1.234,1.234,0,0,0-1.234,1.233v21.908a1.234,1.234,0,0,0,1.234,1.233h15.04a1.234,1.234,0,0,0,1.233-1.233V972.384a1.234,1.234,0,0,0-1.233-1.233Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 19.189,
    height: 2,
    transform: "translate(845.442 989.768)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M856.543,994.512H853.53a1,1,0,0,1,0-2h3.013a1,1,0,0,1,0,2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsIcon);
export default __webpack_public_path__ + "static/media/applicationsIcon.f84d8c7b8b9a7ee95ac369904510c40c.svg";
export { ForwardRef as ReactComponent };